export default "__VITE_ASSET__DSeyAfh9__"